import AsyncSelect from "react-select/async";
import VirtualizedMenuList from "./VirtualizedMenuList";
import { virtualizedDropdownStyles } from "./virtualizedDropdownStyles";

export default function VirtualizedDropdownAsync({
  isMulti,
  isClearable,
  maxMenuHeight,
  value,
  onChange,
  onInputChange,
  previewType,
  onPreview,
  onMenuClose,
  width,
  noOptionsMessage,
  menuPosition,
  menuWidth,
  loadOptions,
  defaultOptions,
  cacheOptions = true,
  isSearchable,
  filterOption,
  ...props
}) {
  return (
    <AsyncSelect
      {...props}
      className="virtualized-dropdown"
      classNamePrefix="rs"
      components={{
        ...(props.components || {}),
        MenuList: VirtualizedMenuList,
      }}
      maxMenuHeight={maxMenuHeight || 700}
      menuPortalTarget={document.body}
      isClearable={isClearable ?? true}
      styles={virtualizedDropdownStyles(width, menuWidth)}
      isMulti={isMulti ?? false}
      value={value}
      previewType={previewType}
      onPreview={onPreview}
      onChange={onChange}
      onInputChange={onInputChange}
      onMenuClose={onMenuClose}
      loadOptions={loadOptions}
      defaultOptions={defaultOptions}
      cacheOptions={cacheOptions}
      isSearchable={isSearchable}
      menuPosition={menuPosition}
      filterOption={filterOption}
      noOptionsMessage={noOptionsMessage}
      menuShouldScrollIntoView={false}
      menuPlacement="auto"
    />
  );
}
